export const APPLY_GUEST_ALREADY_EXISTS_ERROR = "APPLY_GUEST_ALREADY_EXISTS_ERROR";
